// temporary hook
import { useSelector } from 'react-redux';
import { brandSelector } from '../redux/reducers/app/params';
import { SCCOM_BRAND } from '../constants/noNameBrands';

export const useIsSSCOMBrand = () => {
  const brand = useSelector(brandSelector);

  return brand === SCCOM_BRAND;
};
